import {
  Entitlement,
  EntitlementKind,
  isValidEntitlement,
  List,
} from "@blacknut/javascript-sdk/dist";
import { logE } from "@blacknut/logging/dist";
import { getEntitlementCRMPriceInfo, State } from "core/index";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isTryBuy } from "src/utils/subscription";
import { LOGGING_TAG } from "src/utils/Utils";

const useListTitleWithEntitlement = (list: List) => {
  const { subscription } = useSelector((state: State) => state.globalState);
  const { entitlements } = subscription;
  const dispatch = useDispatch();
  let entitlement: Entitlement | undefined;
  const [title, setTitle] = useState(list.title);

  if (list.entitlement) {
    entitlement = entitlements.find((e) => e.uuid == list.entitlement);
  }
  useEffect(() => {
    if (entitlement) {
      const init = async () => {
        if (entitlement) {
          const main = entitlements.find((e) => e.kind === EntitlementKind.MAIN);
          try {
            const crmInfo = await getEntitlementCRMPriceInfo({
              entitlementId: entitlement.uuid,
              bundle: !isValidEntitlement(main) || isTryBuy(main),
            })(dispatch);
            setTitle(crmInfo.listText.replace(/<br\/?>/, " "));
          } catch (e) {
            logE(LOGGING_TAG, "Caught error getting entilement crm info: %o", e);
          }
        }
      };
      init();
    }
  }, [dispatch, entitlement, entitlements]);
  return {
    title,
  };
};

export default useListTitleWithEntitlement;
export { useListTitleWithEntitlement };
